import React, { useState } from "react";

const MessageA3SeeMore = ({ item }) => {
  const [expanded, setExpanded] = useState({ chosen: false, comp: false, generic: {} });

  // Extract array from text (remove quotes too)
  const extractArray = (text) => {
    const match = text.match(/\[([^\]]+)\]/);
    if (match) {
      return match[1]
        .split(",")
        .map((app) => app.trim().replace(/^["']+|["']+$/g, ""));
    }
    return [];
  };

  // Helper to wrap the key with font-weight 700
  const boldKey = (line, key) => {
    return line.replace(
      new RegExp(`${key}\\s*:`, "i"),
      `<span style="font-weight:600">${key}:</span>`
    );
  };

  // Format "Choosen Apps" line (always show all)
  const formatChosenApps = (line) => {
    const apps = extractArray(line);
    const replaced = line.replace(/\[[^\]]+\]/, apps.join(" | "));
    return boldKey(replaced, "Choosen Apps");
  };

  // Format "Complimentary Apps" line with see more logic
  const formatCompApps = (line, isExpanded) => {
    const apps = extractArray(line);
    if (apps.length <= 3) {
      const replaced = line.replace(/\[[^\]]+\]/, apps.join(" | "));
      return boldKey(replaced, "Complimentary Apps");
    }

    const visibleApps = isExpanded ? apps : apps.slice(0, 3);
    const appsHtml = visibleApps.join(" | ");
    const toggleText = isExpanded ? "Show Less" : "See More";
    const toggleLink = `<span data-type="comp" style="color: blue; cursor: pointer; text-decoration: underline;">${toggleText}</span>`;

    const replaced = line.replace(/\[[^\]]+\]/, `${appsHtml} ${toggleLink}`);
    return boldKey(replaced, "Complimentary Apps");
  };

  //  NEW: Format generic array lines (without specific keys)
//   const formatGenericArray = (line, idx) => {
//     const apps = extractArray(line);
//     if (apps.length === 0) return line;

//     const isExpanded = expanded.generic[idx] || false;

//     if (apps.length <= 3) {
//       // simply join with |
//       return line.replace(/\[[^\]]+\]/, apps.join(" | "));
//     }

//     const visibleApps = isExpanded ? apps : apps.slice(0, 3);
//     const appsHtml = visibleApps.join(" | ");
//     const toggleText = isExpanded ? "Show Less" : "See More";
//     const toggleLink = `<span data-type="generic" data-idx="${idx}" style="color: blue; cursor: pointer; text-decoration: underline;">${toggleText}</span>`;

//     return line.replace(/\[[^\]]+\]/, `${appsHtml} ${toggleLink}`);
//   };

  const formatGenericArray = (line) => {
    const apps = extractArray(line);
    if (apps.length === 0) return line;
  
    // Always join with |
    return line.replace(/\[[^\]]+\]/, apps.join(" | "));
  };
  

  // Handle clicks on the inline toggle
  const handleClick = (e) => {
    const type = e.target.getAttribute("data-type");
    if (type === "comp") {
      setExpanded((prev) => ({ ...prev, comp: !prev.comp }));
    }
    if (type === "generic") {
      const idx = e.target.getAttribute("data-idx");
      setExpanded((prev) => ({
        ...prev,
        generic: { ...prev.generic, [idx]: !prev.generic[idx] }
      }));
    }
  };

  // Build final HTML (split on any <br>, <br/> or <br />)
  const getFormattedText = () => {
    return item.text
      .split(/<br\s*\/?>/gi)
      .map((line, idx) => {
        if (/Choosen Apps/i.test(line)) return formatChosenApps(line);
        if (/Complimentary Apps/i.test(line)) return formatCompApps(line, expanded.comp);
        //  For any other line with an array
        if (/\[[^\]]+\]/.test(line)) return formatGenericArray(line, idx);
        return line;
      })
      .join("<br>");
  };

  return (
    <div style={{ display: "flex", width: "100%" }}>
      <div
        className="chat-text"
        style={{ marginBottom: "6px" }}
        dangerouslySetInnerHTML={{ __html: getFormattedText() }}
        onClick={handleClick}
      />
    </div>
  );
};

export default MessageA3SeeMore;
